// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"426":"882f99bf","604":"cea9c9c6","729":"385217ba","870":"74d6470d","911":"bb152cac"}[chunkId] + ".chunk.css";
};